import { InjectionToken } from '@angular/core';
import { GdAccess } from './gd-access.models';

/** App-provided Analytics Studio access. Deliberately has no default factory: a missing
 * provider must fail loudly rather than silently deny or grant access. */
export const GD_ACCESS = new InjectionToken<GdAccess>('GD_ACCESS');
